module.exports = __webpack_public_path__ + "79ada9d6b57b3ef105890975fbb794a8.png";